<ng-container *transloco="let t">
  <div class="p-1">

    <div class="flex flex-row items-center gap-1 mb-2">
      <span cdkDragHandle class="flex items-center cursor-move">
        <i class="iconify text-lg opacity-60" data-icon="mdi:drag"></i>
      </span>
      <span class="flex-1 text-sm font-medium truncate">{{ field?.label }}</span>

      <button mat-icon-button [matMenuTriggerFor]="menu">
     <i class="iconify scale-80! opacity-80" data-icon="mdi:dots-vertical"></i>
      </button>

      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="clear()">
          <div class="flex items-center gap-2">
                 <i class="iconify text-2xl opacity-80" data-icon="solar:eraser-linear"></i>
            <span>{{ t('Clear') }}</span>
          </div>
        </button>
        <button mat-menu-item (click)="removed.emit()">
          <div class="flex items-center gap-2">
            <i class="iconify text-2xl opacity-80" data-icon="solar:trash-bin-2-outline"></i>
            <span>{{ t('Remove filter') }}</span>
          </div>
        </button>
      </mat-menu>
    </div>

    <div class="flex flex-row flex-wrap gap-2">
      <mat-form-field appearance="outline" class="w-full no-subscript">
        <mat-select [ngModel]="operator" (ngModelChange)="onOperatorChange($event)" [disabled]="disabled()">
          @for (option of operators; track option.value) {
          <mat-option [value]="option.value">{{ t(option.label) }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- @if (isList) {
      <div class="flex flex-row flex-wrap gap-2">
        dddd
        <mat-form-field appearance="outline" class="flex-1 no-subscript">
          <mat-chip-grid #chipGrid [disabled]="disabled()">
            @for (item of items; track $index) {
            <mat-chip-row (removed)="removeItem($index)">
              {{ item.code }}
              <button matChipRemove [attr.aria-label]="t('Remove')">
                <i class="iconify text-sm" data-icon="mdi:close"></i>
              </button>
            </mat-chip-row>
            }
          </mat-chip-grid>
          <input [matChipInputFor]="chipGrid" [matChipInputSeparatorKeyCodes]="separatorKeys"
            (matChipInputTokenEnd)="onChipInputTokenEnd($event)" [disabled]="disabled()">
        </mat-form-field>
      </div>
      } @else { -->
      <mat-form-field appearance="outline" class="flex-1 no-subscript">
        <input matInput [ngModel]="value" (ngModelChange)="onValueChange($event)" [disabled]="disabled()">
      </mat-form-field>
      <!-- } -->
    </div>

  </div>
</ng-container>
